import { EditIcon, EyeIcon, TrashIcon } from "assets";
import {
  Card,
  CustomTooltip,
  MediumScreenModel,
  SmallScreenModel,
} from "components";
import { useState } from "react";
import { FaqProps } from "../state/actionType";
import HandlerUpdateFAQ from "./HandleUpdateFAQ";
import HandleDeleteFAQ from "./HandleDeleteFAQ";
import PreviewFAQ from "./components/PreviewFAQ";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../props/enum';

const ActionButton: React.FC<{ items: FaqProps }> = ({ items }) => {
  const [viewCard, setViewCard] = useState(false);
  const [isEditModel, setEditModel] = useState(false);
  const [isDeleteModel, setDeleteModel] = useState(false);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_FAQ));
  if (isPermitted)
    return (
      <>
        <div className="flex flex-row gap-2 justify-center">
          <CustomTooltip title="View" placement="bottom">
            <button
              className="hover:text-primary-900"
              onClick={() => setViewCard(true)}
            >
              <EyeIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Edit" placement="bottom">
            <button
              className="hover:text-primary-900"
              onClick={() => setEditModel(true)}
            >
              <EditIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Delete" placement="bottom">
            <button
              className="hover:text-primary-900"
              onClick={() => setDeleteModel(true)}
            >
              <TrashIcon />
            </button>
          </CustomTooltip>
          {viewCard && (
            <MediumScreenModel setShowModal={setViewCard} showModal={viewCard}>
              <PreviewFAQ faqData={items} closeModal={setViewCard} />
            </MediumScreenModel>
          )}
          {isEditModel && (
            <SmallScreenModel
              setShowModal={setEditModel}
              showModal={isEditModel}
            >
              <HandlerUpdateFAQ closeModal={setEditModel} faqData={items} />
            </SmallScreenModel>
          )}
          {isDeleteModel && (
            <SmallScreenModel
              setShowModal={setDeleteModel}
              showModal={isDeleteModel}
            >
              <HandleDeleteFAQ closeModal={setDeleteModel} faqData={items} />
            </SmallScreenModel>
          )}
        </div>
      </>
    );
  return <></>;
};
export default ActionButton;
